import React from 'react';

export default function ShortText(text, value = 30) {
  const shortText = (text || '').length > value ? text.slice(0, value) + '...' : text;
  return (
    shortText
  );
}
